import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 21H5a2 2 0 0 1-2-2v-5.333a2 2 0 0 1 2-2h2V21Zm5.154-18c.695 0 2.433 1 2.433 2.999 0 2-.348 3.333.694 3.333.695 0 3.473-.333 4.516 0 1.172.375 2.254 1.356 1.737 4.333-.347 2-.467 4.801-1.737 6.332-.692.834-2.99.98-4.897 1H8.333v-9.33C9.375 8.89 11.598 3.003 12.154 3Z" }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }